import { render, staticRenderFns } from "./EntityBeneficialOwnersWrapper.vue?vue&type=template&id=1680bb50&scoped=true&"
import script from "./EntityBeneficialOwnersWrapper.vue?vue&type=script&lang=js&"
export * from "./EntityBeneficialOwnersWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1680bb50",
  null
  
)

export default component.exports